/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureSourceAccountAttributes {
  /**
  * ID of the Azure tenant the subscription belongs to.
  */
  'tenantId': string;
  /**
  * The application ID
  */
  'applicationId'?: string;
  /**
  * The principal ID
  */
  'principalId'?: string;
  /**
  * The management group internal id
  */
  'managementGroupId'?: string;
  /**
  * Resource group name.
  */
  'eonResourceGroupName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "principalId",
      "baseName": "principalId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementGroupId",
      "baseName": "managementGroupId",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonResourceGroupName",
      "baseName": "eonResourceGroupName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSourceAccountAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

